import { render, staticRenderFns } from "./BaseSkipButton.vue?vue&type=template&id=08580df4&scoped=true"
import script from "./BaseSkipButton.vue?vue&type=script&lang=js"
export * from "./BaseSkipButton.vue?vue&type=script&lang=js"
import style0 from "./BaseSkipButton.vue?vue&type=style&index=0&id=08580df4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08580df4",
  null
  
)

export default component.exports